import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, FileText, Globe, Scale } from 'lucide-react';
import { Button } from '../components/ui/button';

const Terms = () => {
    return (
        <div className="min-h-screen bg-[#020617] text-slate-300 p-6 md:p-12 font-['Inter']">
            <div className="max-w-4xl mx-auto">
                <Link to="/register" className="inline-flex items-center text-slate-400 hover:text-white mb-8 transition-colors group">
                    <ArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" size={20} />
                    Back to Signup
                </Link>

                <div className="bg-slate-900/40 backdrop-blur-xl border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="w-12 h-12 bg-blue-600/20 rounded-xl flex items-center justify-center border border-blue-500/30">
                            <FileText className="text-blue-400" size={28} />
                        </div>
                        <div>
                            <h1 className="text-3xl md:text-4xl font-bold text-white mb-1">Terms & Conditions</h1>
                            <p className="text-slate-500 text-sm">Last updated: February 14, 2026</p>
                        </div>
                    </div>

                    <div className="space-y-8 text-slate-400 leading-relaxed">
                        <section>
                            <h2 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                                <Globe size={20} className="text-blue-400" />
                                1. Acceptance of Services
                            </h2>
                            <p>
                                By creating an account and using the FinAssure platform, you agree to abide by these Terms and Conditions. FinAssure provides financial tracking, investment analysis, and automated insights. We reserve the right to modify these terms at any time.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                                <Shield size={20} className="text-emerald-400" />
                                2. Data Privacy & Security
                            </h2>
                            <p>
                                Your financial data is encrypted using industry-standard protocols. We do not sell your personal information to third parties. We use your data solely to provide personalized financial insights and to improve our services.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                                <Lock size={20} className="text-purple-400" />
                                3. User Responsibilities
                            </h2>
                            <p>
                                You are responsible for maintaining the confidentiality of your account credentials. Any unauthorized use of your account should be reported immediately. You agree not to use the platform for any fraudulent or illegal financial activities.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                                <Scale size={20} className="text-orange-400" />
                                4. Accuracy of Financial Data
                            </h2>
                            <p>
                                While we strive to ensure the accuracy of stock and market data provided via our APIs, market conditions are volatile. FinAssure is an informational tool and should not be considered professional financial advice.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                                <FileText size={20} className="text-blue-400" />
                                5. Account Termination
                            </h2>
                            <p>
                                We reserve the right to suspend or terminate accounts that violate our terms or engage in behavior that threatens the security and integrity of the platform.
                            </p>
                        </section>
                    </div>

                    <div className="mt-12 pt-8 border-t border-white/5">
                        <p className="text-sm text-slate-500 italic">
                            If you have any questions regarding these terms, please contact our support team at security@finassure.pro.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Terms;
